import { useState } from 'react';
import PropTypes from 'prop-types';
import Translate from 'components/Translate';
import Carousel from 'components/UI/Carousel';
import './styles.scss';

const POSITIONS = {
  center: 'justify-center',
  start: 'justify-start',
  end: 'justify-end',
};

const Slides = (props) => {
  const {
    slides = [],
  } = props;

  const [active, setActive] = useState(0);

  const handleOnSlideChange = (e) => {
    setActive(e.activeIndex);
  };

  const slidesList = slides.map((slide) => {
    const {
      id,
      title,
      description,
      justify,
      image,
    } = slide;

    return (
      <div key={`slide-${id}`}>
        {slide.image ? (
          <div className={`slide-img mb-6 lg:mb-12 ${POSITIONS[justify] || 'justify-center'}`}>
            <img src={image} alt={title} />
          </div>
        ) : null}
        <div className='slide-step mb-6 lg:mb-12'>
          {slides.map((_, index) => (
            <span key={`dot-${index}`} className={active === index ? 'active' : ''} />
          ))}
        </div>
        <div className='slide'>
          {title && <Translate component='h1' className='mb-4' literal={title} />}
          {description && <Translate component='p' className='mb-0' literal={description} />}
        </div>
      </div>
    );
  });

  return (
    <div className='slides'>
      <Carousel
        slides={slidesList}
        onSlideChange={handleOnSlideChange}
        autoPlay={{
          delay: 15000,
          disableOnInteraction: true,
        }}
        autoHeight={false}
      />
    </div>
  );
};

Slides.propTypes = {
  slides: PropTypes.array.isRequired,
};

export default Slides;
